import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=1afddd16&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=1afddd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afddd16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1afddd16')) {
      api.createRecord('1afddd16', component.options)
    } else {
      api.reload('1afddd16', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=1afddd16&scoped=true&", function () {
      api.rerender('1afddd16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FoT01mGOVNWN/JS/comp/SearchFilterTokens.vue"
export default component.exports